import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Radio,
  Pagination,
  Modal,
  ThemeProvider,
  createTheme,
  IconButton,
  CircularProgress,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const theme = createTheme({
  typography: {
    fontFamily: "Manrope, Arial, sans-serif",
  },
});

const TestRailSuitesComponentPage = ({
  selectedProject,
  suitesList,
  setSuitesList,
  suitesLoading,
  selectedSuite,
  setSelectedSuite,
  setOpenSuitePage,
  onSuiteSelect,
  setALMModalOpen,
  setProceedingMap,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  const suitesPerPage = 6;

  const filteredSuites = suitesList.filter((suite) =>
    suite.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const displayedSuites = filteredSuites.slice(
    (page - 1) * suitesPerPage,
    page * suitesPerPage
  );

  const handleCloseModal = () => {
    setOpenSuitePage(false);
    setALMModalOpen(false);
  };

  const handleRadioChange = (suite) => {
    setSelectedSuite(suite); // triggers navigation from parent
    onSuiteSelect(suite); // ⬅️ Trigger API call
  };

  const handleBack = () => {
    setSuitesList([]);
    setSelectedSuite(null);
    setOpenSuitePage(false);
    setProceedingMap(null);
  };

  return (
    <ThemeProvider theme={theme}>
      <Modal open={true} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "550px",
            height: "500px",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 3,
            display: "flex",
            flexDirection: "column",
            outline: "none",
          }}
        >
          {/* <IconButton
            size="small"
            sx={{ color: "black", "& svg": { fontSize: "0.9rem" } }}
            onClick={handleBack}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <IconButton
            onClick={handleCloseModal}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" sx={{ mb: 2 }}>
            Select Suite from {selectedProject?.name}
          </Typography> */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <ArrowBackIosNewIcon
                fontSize="small"
                onClick={handleBack}
                sx={{ mr: 1, cursor: "pointer" }}
              />
              <Typography sx={{ fontSize: "17px" }}>
                Select Suite from {selectedProject?.name}
              </Typography>
            </Box>

            <IconButton
              onClick={handleCloseModal}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              Choose a suite to continue
            </Typography>
            <TextField
              size="small"
              placeholder="Search suites"
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
              sx={{ width: "200px", ml: 2 }}
            />
          </Box>

          {suitesLoading ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : filteredSuites.length === 0 ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography>No suites found</Typography>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: 1.5,
                  flex: 1,
                  overflowY: "auto",
                }}
              >
                {displayedSuites.map((suite, index) => (
                  <Card
                    key={index}
                    variant="outlined"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "250px",
                      height: "90px",
                      p: 1,
                      borderRadius: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", ml: -1 }}>
                      <Radio
                        checked={selectedSuite?.id === suite.id}
                        onChange={() => handleRadioChange(suite)}
                        value={suite}
                        name="testrail-suite-radio"
                      />
                      <Typography variant="body2" fontWeight="bold">
                        {suite.name}
                      </Typography>
                    </Box>
                  </Card>
                ))}
              </Box>

              <Pagination
                count={Math.ceil(filteredSuites.length / suitesPerPage)}
                page={page}
                onChange={(e, val) => setPage(val)}
                sx={{ mt: 2, display: "flex", justifyContent: "center" }}
              />
            </>
          )}
        </Box>
      </Modal>
    </ThemeProvider>
  );
};

export default TestRailSuitesComponentPage;
